import useCurrentUser from './use-current-user';

export default function useUserStats() {
  const { stats } = useCurrentUser();

  return stats;
}
